/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionBrowseFacetCount } from './CompetitionBrowseFacetCount';
import {
    CompetitionBrowseFacetCountFromJSON,
    CompetitionBrowseFacetCountFromJSONTyped,
    CompetitionBrowseFacetCountToJSON,
    CompetitionBrowseFacetCountToJSONTyped,
} from './CompetitionBrowseFacetCount';

/**
 * 
 * @export
 * @interface CompetitionBrowseFacets
 */
export interface CompetitionBrowseFacets {
    /**
     * 
     * @type {Array<CompetitionBrowseFacetCount>}
     * @memberof CompetitionBrowseFacets
     */
    types: Array<CompetitionBrowseFacetCount>;
    /**
     * 
     * @type {Array<CompetitionBrowseFacetCount>}
     * @memberof CompetitionBrowseFacets
     */
    statuses: Array<CompetitionBrowseFacetCount>;
    /**
     * 
     * @type {Array<CompetitionBrowseFacetCount>}
     * @memberof CompetitionBrowseFacets
     */
    games: Array<CompetitionBrowseFacetCount>;
    /**
     * 
     * @type {Array<CompetitionBrowseFacetCount>}
     * @memberof CompetitionBrowseFacets
     */
    entry: Array<CompetitionBrowseFacetCount>;
}

/**
 * Check if a given object implements the CompetitionBrowseFacets interface.
 */
export function instanceOfCompetitionBrowseFacets(value: object): value is CompetitionBrowseFacets {
    if (!('types' in value) || value['types'] === undefined) return false;
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    if (!('games' in value) || value['games'] === undefined) return false;
    if (!('entry' in value) || value['entry'] === undefined) return false;
    return true;
}

export function CompetitionBrowseFacetsFromJSON(json: any): CompetitionBrowseFacets {
    return CompetitionBrowseFacetsFromJSONTyped(json, false);
}

export function CompetitionBrowseFacetsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionBrowseFacets {
    if (json == null) {
        return json;
    }
    return {
        
        'types': ((json['types'] as Array<any>).map(CompetitionBrowseFacetCountFromJSON)),
        'statuses': ((json['statuses'] as Array<any>).map(CompetitionBrowseFacetCountFromJSON)),
        'games': ((json['games'] as Array<any>).map(CompetitionBrowseFacetCountFromJSON)),
        'entry': ((json['entry'] as Array<any>).map(CompetitionBrowseFacetCountFromJSON)),
    };
}

export function CompetitionBrowseFacetsToJSON(json: any): CompetitionBrowseFacets {
    return CompetitionBrowseFacetsToJSONTyped(json, false);
}

export function CompetitionBrowseFacetsToJSONTyped(value?: CompetitionBrowseFacets | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'types': ((value['types'] as Array<any>).map(CompetitionBrowseFacetCountToJSON)),
        'statuses': ((value['statuses'] as Array<any>).map(CompetitionBrowseFacetCountToJSON)),
        'games': ((value['games'] as Array<any>).map(CompetitionBrowseFacetCountToJSON)),
        'entry': ((value['entry'] as Array<any>).map(CompetitionBrowseFacetCountToJSON)),
    };
}

